var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cn-news-section-skeleton"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"cn-news-section-skeleton__content"},_vm._l((6),function(i){return _c('div',{key:i},[_c('ShopCardSkeleton')],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }